import {pick} from "@pg-mono/nodash";
import type {IQueryValue} from "@pg-mono/request";

import {OfferType} from "../../types/OfferType";

type IQueryFilters = Record<string, IQueryValue | undefined> | null | undefined;

const commonFilterKeys = ["area_0", "area_1", "price_0", "price_1", "rooms_0", "rooms_1"] as const;

export const getOfferDetailPropertyListQueryFilters = (filters: IQueryFilters, offerType?: OfferType): Record<string, IQueryValue | undefined> => {
    const filterKeys = [
        ...commonFilterKeys,
        ...(offerType === OfferType.FLAT ? ["floor_choices"] : []),
        ...(offerType === OfferType.HOUSE ? ["house_storeys"] : [])
    ];

    return pick(filters ?? {}, filterKeys);
};
import {pick} from "@pg-mono/nodash";
import type {IQueryValue} from "@pg-mono/request";

import {OfferType} from "../../types/OfferType";

type IQueryFilters = Record<string, IQueryValue | undefined> | null | undefined;

const commonFilterKeys = ["area_0", "area_1", "price_0", "price_1", "rooms_0", "rooms_1"] as const;

export const getOfferDetailPropertyListQueryFilters = (filters: IQueryFilters, offerType?: OfferType): Record<string, IQueryValue | undefined> => {
    const filterKeys = [
        ...commonFilterKeys,
        ...(offerType === OfferType.FLAT ? ["floor_choices"] : []),
        ...(offerType === OfferType.HOUSE ? ["house_storeys"] : [])
    ];

    return pick(filters ?? {}, filterKeys);
};
